export enum Service {
  AMBULANCIAS = "01",
  ATENCIONES_ENEMERGENCIA_SANITARIA = "132",
  CONSULTAS_MEDICAS_CUALQUIER_ESPECIALIDAD = "11",
  EMERGENCIA = "49",
  EMERGENCIA_TRIAGE_I = "126",
  EMERGENCIA_TRIAGE_II = "127",
  EMERGENCIA_TRIAGE_III = "128",
  EMERGENCIA_TRIAGE_IV = "129",
  EMERGENCIA_TRIAGE_V = "130",
  ESTUDIOS_ESPECIALIZADOS = "20",
  HOSPITALIZACIÓN_NO_QUIRURGICA = "28",
  LABORATORIO_PATOLOGICO = "32",
  LABORATORIOS = "33",
  NEUROCIRUGÍAS = "102",
  PROGRAMA_AMPLIADO_DE_INMUNIZACIÓN = "108",
  PSIQUIATRIA = "43",
  RAYOS_X = "46",
  SALUD_ESCOLAR = "113",
  TERAPIAS_FISICAS = "72",
  SERVICIOS_ODONTOLOGICOS = "65",
  UCI_EN_EMERGENCIA_SANITARIA = "133",
}
